// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__POwWP","colMin":"styles_colMin__WLce9","colCheckbox":"styles_colCheckbox__2YnWO"};